"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 1.2rem;\n  font-weight: 500;\n  line-height: 1.42;\n  letter-spacing: 0.035em;\n  margin: 30px 0;\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Legal = _styledComponents.default.p.attrs(function (_ref) {
  var className = _ref.className;
  return {
    className: className || 'legal'
  };
})(_templateObject(), function (props) {
  return props.color || _Constant.Color.MEDIUM_GREY;
});

Legal.displayName = 'Legal';
var _default = Legal;
exports.default = _default;